/* global $:false */

export default class MarketLotShowBidFormResponse {
  constructor () {
    this.findElements = this.findElements.bind(this)
    this.loadForm = this.loadForm.bind(this)
    this.loadDismissButtons = this.loadDismissButtons.bind(this)
    this.closeSoon = this.closeSoon.bind(this)
    this.resetCloseSoon = this.resetCloseSoon.bind(this)
    this.close = this.close.bind(this)
    this.message = this.message.bind(this)
    this.additionalMessage = this.additionalMessage.bind(this)
    this.findElements()
    this.loadForm()
    this.loadDismissButtons()
    this.refreshCallback = function () {}
  }

  findElements () {
    this.form = $('.js-market-lot-show-form')
    this.dialog = this.form.find('[data-identifier=bidding_dialog]')
    this.amountField = this.form.find('[data-identifier=bid_form_amount]')
    this.title = this.dialog.find('[data-identifier=bidding_dialog_title]')
    this.body = this.dialog.find('[data-identifier=bidding_dialog_body]')
    this.dismissButton = this.dialog.find('[data-identifier=bidding_dialog_button_dismiss]')
    this.confirmButton = this.dialog.find('[data-identifier=bidding_dialog_button_confirm]')

    this.footer = this.dialog.find('[data-identifier=bidding_dialog_footer]')
    this.additionalNoticeContainer = this.dialog.find('[data-identifier=bidding_dialog_additional_notice_container]')
    this.additionalNotice = this.dialog.find('[data-identifier=bidding_dialog_additional_notice]')
    this.placeBidButton = this.form.find('[data-identifier=place_bid_button]')
  }

  loadForm () {
    return this.form.submit(event => {
      // If the Amount field is disabled, its value will not be sent to the Controller.
      // Whenever we submit the place bid form, we need to make sure that the amount is enabled.
      this.amountField.removeAttr('disabled')
      return true
    })
  }

  loadDismissButtons () {
    this.dialog.find(' [data-identifier=bidding_dialog_button_close], \
[data-identifier=bidding_dialog_button_dismiss]').on('click', event => {
      this.close()
      return false
    })
  }

  closeSoon () {
    this.closer = setTimeout(() => {
      return this.close()
    }
    , 1000 * 30)
  }

  resetCloseSoon () {
    clearTimeout(this.closer)
  }

  close () {
    this.form.attr('action', this.form.data('check-bid-action'))
    // When we close the dialog, the user is allowed to change the bid amount again.
    this.amountField.removeAttr('disabled')

    // Enable place bid button again to allow user to reopen dialog
    this.placeBidButton.removeAttr('disabled')

    this.refreshPanel()
    this.dialog.hide()
  }

  // In case Websockets are down, we want to be able to refresh manually
  refreshPanel () {
    this.refreshCallback()
  }

  message (title, body, style) {
    this.resetCloseSoon()
    this.additionalNoticeContainer.hide()
    this.title.html(title)
    this.body.html(body)
    switch (style) {
      case 'export_ban':
        this.dismissButton.hide()
        this.confirmButton.show()
        this.footer.hide()
        break
      case 'verify':
        this.dismissButton.hide()
        this.confirmButton.show()
        this.footer.hide()
        break
      case 'confirm':
        this.dismissButton.hide()
        this.confirmButton.show()
        this.footer.show()
        break
      default:
        this.dismissButton.show()
        this.confirmButton.hide()
        this.footer.hide()
        // If we show a "you are leading" dialog, there is a risk that
        // another user places a higher bid and our user doesn't
        // notice that he is not leading any more. That's why we close
        // the dialog before the bidding time ends.
        this.closeSoon()
    }

    // As long as a dialog is open, we need to prevent that the user
    // can change the amount.
    this.amountField.attr('disabled', true)
    // Re-enabling all buttons
    this.dismissButton.removeAttr('disabled')
    this.confirmButton.removeAttr('disabled')
    // On Chrome, if the user had the focus() inside the amount text
    // field, the disabling does not have any effect.
    this.amountField.blur()
    this.refreshPanel()
    // Ready to display the dialog.
    this.dialog.show()
  }

  additionalMessage (content) {
    this.additionalNotice.html(content)
    this.additionalNoticeContainer.show()
  }
}
